import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { Button, Col, Input, Row, Space, Table, Tag } from 'antd';
import Column from 'antd/es/table/Column';
import { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import { ContentHeader } from "../../components";
import { searchLength } from '../../constants';
import { Links } from '../../helpers/Links';
import { menuHelper } from '../../helpers/account';
import { dateCommon } from "../../helpers/common";
import { TimKiemToBanResponse } from '../../models/toban/ToBan';
import { timKiemDSToBan } from '../../services/toban';

const DanhSachToBan = () => {
    const [danhsach, setDanhSach] = useState < Array<TimKiemToBanResponse>>([]);
    const [page, setPage] = useState(1);
    const [tuKhoa, setTuKhoa] = useState<string>("");
    const menu: any = menuHelper.checkMultiPermission([Links.NhanVien.ChiTiet]);
    const [reloadPage, setReloadPage] = useState<boolean>(true);
    const [isLoadingTable, setIsLoadingTable] = useState<boolean>(false);

    const timkiem = async (tuKhoa: string) => {
        try {
            setPage(1);
            setIsLoadingTable(true);
            const temp = await timKiemDSToBan(tuKhoa);
            setDanhSach(temp || []);
            setIsLoadingTable(false);
        }
        catch (error: any) {
            setIsLoadingTable(false);
        };
    }

    useEffect(() => {
        if (reloadPage) {
            setDanhSach([]);
            timkiem(tuKhoa);
            setReloadPage(false);
        }
    }, [reloadPage]);

    const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            timkiem(tuKhoa)
        }
    };
    return (<section>
        <ContentHeader title="Quản lý tổ ban" />
        <Row className="form-group" gutter={8}>
            <Col span={8}>
                <Input prefix={<SearchOutlined rev="" />} placeholder="Nhập tên, số quyết định thành lập tổ ban" onChange={(e) => setTuKhoa(e.target.value)}
                    onKeyPress={handleKeyPress} />
            </Col>
            <Col span={8}>
                <Space>
                    <Button type="primary" icon={<SearchOutlined rev="" />} onClick={() => timkiem(tuKhoa)}>
                        Tìm kiếm
                    </Button>
                </Space>
            </Col>
            <Col span={8}>
                {
                    menu[Links.NhanVien.ChiTiet] &&
                    <Link className="hrm-btn float-right hrm-btn-warning" to={Links.ToBan.ChiTiet} > <PlusOutlined rev="" />Thêm mới </Link>
                }
            </Col>
        </Row>
        <Row gutter={8}>
            <Col span={24}>
                <div className="card card-primary">
                    <Row>
                        <Col span={24}>
                            <Table
                                loading={isLoadingTable}
                                locale={{ emptyText: "Không có dữ liệu" }}
                                dataSource={(danhsach || []).map((item: any) => { item.key = item.id; return item })}
                                pagination={{
                                    current: page,
                                    onChange: (page, pageSize) => {
                                        setPage(page);
                                    },
                                }}>
                                <Column
                                    title="STT"
                                    key="STT"
                                    render={(value, record, index) =>
                                    (
                                        <span key={"stt" + index}>
                                            {(page - 1) * searchLength +index + 1}
                                        </span>
                                    )
                                    }
                                />
                                <Column title="Tên tổ ban" dataIndex="ten" key="ten" />
                                <Column title="Số quyết định" dataIndex="soQuyetDinh" key="soQuyetDinh" />
                                <Column
                                    title="Ngày ký quyết định"
                                    key="ngayBatDau"
                                    width={"210px"}
                                    render={(value, record, index) =>
                                    (<span key={"ngayKyQuyetDinh" + index}>
                                        {dateCommon.formatDate(value?.ngayKyQuyetDinh)}
                                        </span>
                                        )

                                    }
                                />
                                <Column align="center" title="SL thành viên" dataIndex="soLuongNhanVien" key="soLuongNhanVien" />
                                <Column
                                    title="Trạng thái"
                                    key="trangThai"
                                    render={(value, record, index) =>
                                    (
                                        <Tag color={value.trangThai == 1 ? "green" : "red"}>{value.trangThai == 1 ? "Hiệu lực" : "Hết hiệu lực"}</Tag>
                                    )
                                    }
                                />
                                <Column
                                    title=""
                                    key="action"
                                    render={(value, record, index) =>
                                    (
                                        <div className="action">
                                        <Link key={"xem" + index} className="hrm-btn hrm-btn-sm  btn-primary" to={`${Links.ToBan.Xem}?id=${value?.id}`}>Xem</Link>
                                        </div>
                                    )
                                    }
                                />
                            </Table>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    </section>
    );
}
export default DanhSachToBan;